var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.168 9.00004L6.83197 5.66804V8.16804H0.167969V9.83204H6.83197V12.332L10.168 9.00004ZM16.832 9.00004C16.8311 10.9903 16.1179 12.9145 14.8215 14.4246C13.525 15.9346 11.7309 16.9308 9.76371 17.2329C7.79651 17.5349 5.78617 17.123 4.09637 16.0714C2.40658 15.0199 1.14893 13.3983 0.550969 11.5H2.32397C2.90481 12.9336 3.96597 14.1207 5.32573 14.8579C6.68549 15.5952 8.25927 15.8368 9.77756 15.5413C11.2959 15.2459 12.6642 14.4318 13.6483 13.2385C14.6324 12.0451 15.1711 10.5468 15.172 9.00004C15.1711 7.45327 14.6324 5.95493 13.6483 4.76161C12.6642 3.56828 11.2959 2.75419 9.77756 2.45876C8.25927 2.16332 6.68549 2.40492 5.32573 3.14217C3.96597 3.87943 2.90481 5.06647 2.32397 6.50004H0.550969C1.14893 4.60175 2.40658 2.98016 4.09637 1.92864C5.78617 0.877131 7.79651 0.465141 9.76371 0.76721C11.7309 1.06928 13.525 2.06546 14.8215 3.57552C16.1179 5.08558 16.8311 7.00979 16.832 9.00004V9.00004Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIn);
export default __webpack_public_path__ + "static/media/check-in.37a675b5486781f2b53e8546d0b9bb5b.svg";
export { ForwardRef as ReactComponent };